<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right">Công ty<span class="required"></span></label>
          <DropdownScrollable placeholder="Chọn công ty" cusClass="text-box m-0" width="100%" :limit="company_obj.limit" :loading="company_obj.loading" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="company_obj.items" :total="company_obj.total" @click="emitEvent" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" @scroll="emitEvent"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên giấy phép mẫu<span class="required"></span></label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập (tối đa 255 ký tự)"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        
        <div class="mt-3">
          <label class="txt-right">DANH SÁCH TIÊU CHÍ</label>
        </div>
        <div class="mt-3">
          <label class="txt-right">Tên tiêu chí<span class="required"></span></label>
          <InputText
            v-model="name_criteria"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập (tối đa 255 ký tự)"
            maxlength="255"
          />
          <input class="input_tmp_validator" id="name_criteria" />
        </div>
        <!-- <div class="mt-3">
          <Checkbox v-model="active_criteria" :binary="true" /> Hiển thị tiêu chí này
        </div> -->
        <div class="mt-3">
          <Button
            @click="AddTieuChi()"
            type="button"
            icon="pi pi-plus"
            class="button-box-1 p-button-add ml-0"
          />
        </div>
        <div class="mt-3">
          <table id="tb_level">
            <tr>
              <th style="width: 50px;">STT</th>
              <th>Tên tiêu chí</th>
              <!-- <th style="width: 110px;">Trạng thái</th> -->
              <!-- <th style="width:90px">Hiển thị</th> -->
              <th style="width: 100px;">Hành động</th>
            </tr>
            <tr v-for="(item, index) in criteria" :key="index">
              <td>{{index+1}}</td>
              <td>{{item.name}}</td>
              <!-- <td>{{item.status_text}}</td> -->
              <!-- <td style="text-align: center;"><span v-html="item.active_text"></span></td> -->
              <td style="text-align: center;" >
                <Button
                  @click="EditItem(index)"
                  icon="pi pi-pencil"
                  class="button-box p-button-edit"
                >
                </Button>
                <Button
                  @click="showDeleteData(index)"
                  icon="pi pi-trash"
                  class="button-box p-button-danger"
                />
          </td>
            </tr>
          </table>
        </div>
        <!-- <div class="mt-3">
          <Checkbox v-model="active" :binary="true" /> Hiển thị giấy phép mẫu này
        </div> -->
      </div>
      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
    <Dialog
    style=""
    header="Cập nhật"
    :visible.sync="showEditDialog"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
      <div class="">
        <label class="txt-right">Tên tiêu chí<span class="required"></span></label>
        <InputText
          v-model="item_edit.name"
          type="text"
          class="text-box-dialog input-text-box"
          placeholder="Nhập"
          maxlength="255"
        />
        <input class="input_tmp_validator" id="name_criteria_edit" />
      </div>
      <!-- <div class="">
        <Checkbox v-model="item_edit.active" :binary="true" /> Hiển thị tiêu chí này
      </div> -->
      
    <template
      #footer
    >
      <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showEditDialog = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  <Dialog
    style=""
    header="Xóa"
    :visible.sync="showDelete"
    :contentStyle="{overflow: 'visible'}"
    :modal="true"
  >
    Bạn có chắc muốn xoá tiêu chí này không?
    <template #footer>
      <Button label="Xác nhận" @click="deleteItem()" icon="pi pi-check" class="" />
      <Button
        label="Hủy"
        @click="showDelete = false"
        icon="pi pi-times"
        class="p-button-cancel"
      />
    </template>
  </Dialog>
  
  </form>
  
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  components: {
    DropdownScrollable
  },
  data() {
    return {
      filters: {},
      name: "",
      code: "",
      name_criteria: "",
      active_criteria: true,
      point : null,
      criteria : [],
      type_login : this.$store.getters.type ? this.$store.getters.type : null,
      criteria_deleted : [],
      showEditDialog : false,
      showApprovedDialog : false,
      item_edit : {
        id: null,
        name: "",
        active: "",
        status : "",
        index : null,
        is_old : true,
      },
      item_approved : {},
      company : {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      active: true,
      listCategory : [],
      selCategory : null,
      selCategory_old : null,
      radio_btn : 1,
      listCriteria : [],
      selCriteria : null,
      showDelete : false,
      index_deleted : false,
      company_obj: {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
    };
  },
  async mounted() {
    await this.getListCompany();
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      setTimeout(() => {
        this.company = this.model.company;
      }, 100);
      this.name = this.model.name;
      this.code = this.model.code;
      this.selCategory_old = {
        id : this.model.id,
        name : this.model.name
      }
      // this.license_criteria = this.model.license_criteria;
      var tmp = this.model.license_criteria;
      var count = tmp.length
      for (let i = 0; i < tmp.length; i++) {
        tmp[i].is_old = true
        tmp[i].ordinal = count-1
        count--
        if(tmp[i].status == 'APPROVED'){
          tmp[i].status_text = 'Đã duyệt'
          if(tmp[i].active == true){
            tmp[i].active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            tmp[i].active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          tmp[i].status_text = 'Chưa duyệt'
          tmp[i].active_text =''
        }
      }
      this.sortDataV2(tmp)
      this.active = this.model.active;
    }
  },
  methods: {
    getCompany(value) {
      this.company = value;
    },
    changeOffset(value) {
      this.company_obj.offset = value;
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.company_obj.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.company_obj.filters, limit: this.company_obj.limit, offset: this.company_obj.offset}, {headers}).then((res) => {
          if (this.company_obj.offset > 0 ) {
              this.company_obj.items.push(...res.data.data.company);
            } else{
              this.company_obj.items = res.data.data.company;
            }
            this.company_obj.total = res.data.data.total;
            this.company_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.company_obj.loading = false;
        })
      }
    },
    EditItem(index){
      const criteria = this.criteria[index];
      this.item_edit = {
        id : criteria.id,
        name: criteria.name,
        status: criteria.status,
        active : criteria.active,
        is_old : criteria.is_old,
        index : index,
        ordinal : criteria.ordinal,
      }
      this.showEditDialog = true
    },
    async validateDataApproved() {
      let name_criteria_approved = document.getElementById("name_criteria_approved");
      if (this.item_approved.name == undefined || this.item_approved.name == null || this.item_approved.name == "") {
        name_criteria_approved.setCustomValidity("Tên tiêu chí không được để trống!");
      } else if (this.item_approved.name.length > 255) {
        name_criteria_approved.setCustomValidity("Tên tiêu chí không được quá 255 ký tự!");
      } else {
        var checkExistName = this.criteria.filter((f, i) => f.name.toLowerCase().trim() == this.item_approved.name.toLowerCase().trim() && i != this.item_approved.index);
        if (checkExistName.length > 0){
          name_criteria_approved.setCustomValidity(`Tên tiêu chí ${this.item_approved.name} đã tồn tại!`);
        } else {
          name_criteria_approved.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    
    toastSuccess(text){
      this.$commonFuction.is_loading(false);
      this.$toast.add({ severity: 'success', summary: 'Success', detail: text, life: 3000 })
    },
    async getCriteriaData(){
      var company_id = this.company?.id ?? null;
      var type_login = this.$store.getters.type ? this.$store.getters.type : null;
      if(type_login != this.$constants.TYPE_USER.SUPPER_ADMIN){
        company_id = this.$store.getters.company_id ?? null;
      }
      var listCriteria = []
      var filters = {id : this.model.id}
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token && company_id && filters.id){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/sample_license/criteria", {filters,limit: null, offset: 0, company_id: company_id}, {headers}).then(async function (response) {
          var data = response.data.data;
          listCriteria = data.list;
        })
      }
      var count = listCriteria.length
      for (let i = 0; i < listCriteria.length; i++) {
        listCriteria[i].is_old = true
        listCriteria[i].ordinal = count-1
        count--
        if(listCriteria[i].status == 'APPROVED'){
          listCriteria[i].status_text = 'Đã duyệt'
          if(listCriteria[i].active == true){
            listCriteria[i].active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            listCriteria[i].active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          listCriteria[i].status_text = 'Chưa duyệt'
          listCriteria[i].active_text =''
        }
      }
      this.sortDataV2(listCriteria);
    },
    
    async EditData(){
    console.log("asdsadsadasd");
      if (await this.validateDataEdit()) {
        return;
      }
      if(this.item_edit.index >= 0){
        var active_text = ''
        var status_text = ''
        if(this.item_edit.status == 'APPROVED'){
          status_text = 'Đã duyệt'
          if(this.item_edit.active == true){
            active_text = '<i class="pi pi-check success bold"></i>'
          }else{
            active_text =  '<i class="pi pi-times danger bold"></i>'
          }
        }else{
          status_text = 'Chưa duyệt'
          active_text =''
        }
        this.criteria[this.item_edit.index] = {
          "id" : this.item_edit.id,
          "name" : this.item_edit.name,
          "active" : this.item_edit.active,
          "status" : this.item_edit.status,
          "is_old" : this.item_edit.is_old,
          "ordinal" : this.item_edit.ordinal,
          "active_text" : active_text,
          "status_text" : status_text,
        }
        var tmp = this.criteria
        this.sortDataV2(tmp);
        this.showEditDialog = false
      }
      
    },
    async AddTieuChi(){
      //check validate
      if (await this.validateDataAdd()) {
        return;
      }
      var tmp = this.criteria
      var status_text = "Đã duyệt"
      var active_text = ``
      // if(this.criteria == true){
      //   active_text = `<i class="pi pi-check success bold"></i>`
      // }else{
      //   active_text = `<i class="pi pi-times danger bold"></i>`
      // }
      var count = this.criteria.length
      tmp.push({
        is_old : false,
        id: null,
        name: this.name_criteria,
        status: 'APPROVED',
        active: this.active_criteria,
        status_text : status_text,
        active_text : active_text,
        ordinal : count
      })
      this.name_criteria= ""
      this.active_criteria = true
      this.sortDataV2(tmp)
    },
    sortDataV2(data){
      var status_w = []
      var status_a = []
      for (let i = 0; i < data.length; i++) {
        if(data[i].status == 'WATTING'){
          status_w.push(data[i])
        }else{
          status_a.push(data[i])
        }
      }
      status_w = this.sortData(status_w,'ordinal','desc')
      // status_a = this.sortData(status_a,'ordinal','asc')
      var tm = [...status_w,...status_a]
      this.criteria = tm
    },
    sortData(arr,key,sort='desc'){
      if(sort == 'desc'){
        return arr.slice().sort(function(a, b) {
          return b[key] - a[key];
        });
      }else{
        return arr.slice().sort(function(a, b) {
          return a[key] - b[key];
        });
      }
    },
    async validateDataAdd() {
      let name_criteria = document.getElementById("name_criteria");
      if (this.name_criteria == undefined || this.name_criteria == null || this.name_criteria == "") {
        name_criteria.setCustomValidity("Tên tiêu chí không được để trống!");
      } else if (this.name_criteria.length > 255) {
        name_criteria.setCustomValidity("Tên tiêu chí không được quá 255 ký tự!");
      } else {
        var checkExistName = this.criteria.filter(f => f.name.toLowerCase().trim() == this.name_criteria.toLowerCase().trim());
        if (checkExistName.length > 0){
          name_criteria.setCustomValidity(`Tên tiêu chí ${this.name_criteria} đã tồn tại!`);
        } else {
          name_criteria.setCustomValidity("");
        }
      }
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validateDataEdit() {
      let name_criteria = document.getElementById("name_criteria");
      name_criteria.setCustomValidity("");

      let name_criteria_edit = document.getElementById("name_criteria_edit");
      if (this.item_edit.name == undefined || this.item_edit.name == null || this.item_edit.name == "") {
        name_criteria_edit.setCustomValidity("Tên tiêu chí không được để trống!");
      } else if (this.item_edit.name.length > 255) {
        name_criteria_edit.setCustomValidity("Tên tiêu chí không được quá 255 ký tự!");
      } else {
        var checkExistName = this.criteria.filter((f, i)=> f.name.toLowerCase().trim() == this.item_edit.name.toLowerCase().trim() && i != this.item_edit.index);
        if (checkExistName.length > 0){
          name_criteria_edit.setCustomValidity(`Tên tiêu chí ${this.item_edit.name} đã tồn tại!`);
        } else {
          name_criteria_edit.setCustomValidity("");
        }
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    showDeleteData(index){
      this.showDelete = true
      this.index_deleted = index
    },
    deleteItem() {
      var index = this.index_deleted
      this.showDelete = false
      var criteria = this.criteria[index];
      if(criteria.id){
        this.criteria_deleted.push(criteria.id)
      }
      this.criteria.splice(index, 1)
    },
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};
      if(this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN){
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }

      let name = document.getElementById("name");
      if (this.name == undefined || this.name == null || this.name == "") {
        name.setCustomValidity("Tên giấy phép mẫu không được để trống!");
      } else if (this.name.length > 255) {
        name.setCustomValidity("Tên giấy phép mẫu không được quá 255 ký tự!");
      } else {
        name.setCustomValidity("");
      }
      
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    validateEmail() {
      var re = /\S+@\S+\.\S+/;
      return re.test(this.email);
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.criteria.length == 0){
        alert("Vui lòng thêm ít nhất một tiêu chí");
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        company: this.company,
        name: this.name,
        criteria: this.criteria,
        active: this.active
      };
      console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);

    },
    isImage(file) {
      return /^image\//.test(file.type);
    },
    async onFileSelect(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (files.length > 0) {
        let acceptTags = [
          "jpeg",
          "jpg",
          "gif",
          "png",
          "JPEG",
          "JPG",
          "PNG",
          "GIF",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            alert(
              "Please upload the image file in the following format: jpeg, jpg, gif, png"
            );
            return;
          }
        }
        if (files.length + this.images.length > this.maxFiles) {
          alert("Hình ảnh quá số lượng tối đa là " + this.maxFiles + " hình");
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            if (this.isImage(file) && file.size <= this.maxFileSize) {
              file.source = file;
              file.objectURL = window.URL.createObjectURL(file);
              arrTemp.push(file);
            }
            if (file.size > this.maxFileSize) arrFiles.push(file);
          }

          if (arrFiles.length > 0) {
            alert("Hình ảnh của bạn đã quá dung lượng 1MB");
          } else {
            if (this.images.length > 0 && this.images[0].file === "") {
              this.imagesDeletes.push(this.images[0]);
            }
            this.images = [];
            this.images = this.images.concat.apply(this.images, arrTemp);
          }
        }
      }
      event.target.value = "";
      return;
    },
    onFileClear(index) {
      let img = this.images[index];
      this.images.splice(index, 1);
      if (img.file === "") this.imagesDeletes.push(img);
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.button-box {
  /* min-height: 45px !important; */
  width: 30px !important;
  height: 30px;
  margin: 2px;
}
.button-box-1 {
  /* min-height: 45px !important; */
  /* width: 30px !important;
  height: 30px; */
  margin-left : 6px;
}
.number-box {
  display: block;
  // min-height: 48px !important;
  width: 46% !important;
}
.text-box-dialog {
  display: block;
  // min-height: 48px !important;
  min-width: 400px;
}
.number-text-box {
  padding-top: 11px !important;
  padding-bottom: 11px !important;
  /* padding-left: 10px !important; */
}
/**css table */
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}

/**end css table */
</style>
